
































































import { Component, Vue } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import { CURRENT_UNIT } from '@/queries/Application';
import { GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import { GQL_warehouseProductReport_warehouseProductReport } from '@/queries/__generated__/warehouseProductReport';
import gql from 'graphql-tag';

const WAREHOUSE_PRODUCT_REPORT = gql`
  query warehouseProductReport($date: Date!, $unitId: ID!, $includeUnlockedOrders: Boolean!) {
    warehouseProductReport(date: $date, unitId: $unitId, includeUnlockedOrders: $includeUnlockedOrders ) {
      suppliersData {
        unit {
          id
          name
        }
        productsData {
          product {
            id
            name
            number
            suppliersProductNumber
          }
          quantity
        }
      }
    }
  }
`;

@Component
export default class WarehouseProuductReport extends Vue{
  private date = this.$dayjs().format('YYYY-MM-DD');
  private includeUnlockedOrders = false;
  private anyProductWithSupplierProductNumber = false;

  private checkForSupplierProductNumber(report: GQL_warehouseProductReport_warehouseProductReport): void {
    if(!report) return;

    let supplierProductNumberPresent = false;
    report.suppliersData.find((supplierData) => {
      return supplierData.productsData.find((productData) => {
        if(productData.product.suppliersProductNumber) {
          supplierProductNumberPresent = true;
          return true;
        }
      });
    });

    this.anyProductWithSupplierProductNumber = supplierProductNumberPresent;
  }

  @SmartQuery(CURRENT_UNIT) private currentUnit!: GQL_currentUnit_currentUnit;

  @SmartQuery<WarehouseProuductReport>({
    query: WAREHOUSE_PRODUCT_REPORT,
    fetchPolicy: 'no-cache',
    skip() { return !this.currentUnit },
    variables() {
      return {
        date: this.date,
        unitId: this.currentUnit.id,
        includeUnlockedOrders: this.includeUnlockedOrders,
      };
    },
    update(data) { return data.warehouseProductReport },
    result({ data }) { this.checkForSupplierProductNumber(data.warehouseProductReport)},
  }) private warehouseReport: GQL_warehouseProductReport_warehouseProductReport | null = null;
}
